import React from "react";
import { RadioButton } from "@msidentity/SISU/components/inputs/radio-button";
import StylesConfigFabric from "@msidentity/SISU/config/styles-config";
import { type AliasListRadioOptions } from "../../../hooks/use-select-alias-filtered-accounts";
import { type SelectedRecoveryAlias } from "../username-recovery-select-alias-view-types";
import RecoveryAliasVerificationInput from "./username-recovery-alias-verification-input";

type RecoveryAliasListProps = {
  radioOptions: AliasListRadioOptions[];
  selectedAlias: SelectedRecoveryAlias | undefined;
  handleAliasSelection: (event: React.ChangeEvent<HTMLInputElement>) => void;
  aliasInputValue: string;
  handleAliasInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: string;
  isMultipleAliases: boolean;
};

/**
 * RecoveryAliasList component
 * @param props - props for RecoveryAliasList component
 * @param props.radioOptions - radio options
 * @param props.selectedAlias - selected alias
 * @param props.handleAliasSelection - function to handle alias selection
 * @param props.aliasInputValue - alias input value
 * @param props.handleAliasInputChange - function to handle alias input change
 * @param props.error - error message
 * @param props.isMultipleAliases - flag to indicate if there are multiple aliases
 * @returns component for recovery alias list
 */
const RecoveryAliasList: React.FC<RecoveryAliasListProps> = function RecoveryAliasList({
  radioOptions,
  selectedAlias,
  handleAliasSelection,
  aliasInputValue,
  handleAliasInputChange,
  error,
  isMultipleAliases,
}) {
  const { useCommonStyles } = StylesConfigFabric.instance;
  const commonStyles = useCommonStyles();
  return (
    <div className={commonStyles.row}>
      {radioOptions.map((option, index) => (
        <div key={option.id}>
          <RadioButton
            {...option}
            aria-describedby="UsernameRecoveryTitle UsernameRecoveryDescription"
            onChange={handleAliasSelection}
          />
          {selectedAlias && option.showInput ? (
            <RecoveryAliasVerificationInput
              selectedRecoveryAlias={selectedAlias.alias}
              index={index}
              aliasInputValue={aliasInputValue}
              handleAliasInputChange={handleAliasInputChange}
              error={error}
              isMultipleAliases={isMultipleAliases}
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default RecoveryAliasList;
